// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1Wwof","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3Txmz"};